// DonateBanner.jsx
import React from "react";
import { Button } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./custom.scss";

const DonateBanner = () => {
  return (
    <div
      className="d-flex justify-content-center align-items-center p-2 donate-banner"
    >
      <span 
        className="me-2 flex-grow-1 small ps-2 "
        >
        Στήριξε το teachers-app.com και βοήθησε να συνεχίσουμε την προσπάθειά μας.
      </span>
      <Button
        variant="warning"
        size="sm"
        className="d-flex align-items-center"
        onClick={() =>
          window.open(
            'https://www.paypal.com/donate/?hosted_button_id=ZT9F4FKHWZ6F2',
            '_blank'
          )
        }
      >
        <img
            src="https://www.paypalobjects.com/webstatic/icon/pp258.png"
            alt="PayPal"
            style={{ width: '20px', height: '20px', marginRight: '8px' }}
        />
        Donate
      </Button>
    </div>
  );
};

export default DonateBanner;